module.exports = __webpack_public_path__ + "img/kaist_thumbnail.aa795d83.jpg";